import classes from './direction-helper.module.css';

export const DirectionHelper = () => {
	return (
		<div className={classes.directionHelper}>
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
};
